import {
  Tooltip,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,

} from "@material-ui/core";
import React, { ReactElement} from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./trendsStyle";
import { selectMessstelleWertTemp } from "../../../features/filter/messstellenFilterSlice";

import { trendsGeneralObject } from "./trendsTypes";
import {
  selectKenngroesseListe,
  selectVertikalSumListe,
  selectHorizentalSumListe,
  selectSumAll,
  selectTrendsListe,
} from "./trendsTableSlice";
import { selectSelectedCell, selectTrendsGraphTabs, setSelectedCell, } from "./trendsSlice";
import { openSnackbar } from "../../../features/snackbar/globalSnackbarSlice";

import { setTrendsCellMenuPositionTop, setTrendsCellMenuPositionLeft, setTrendsCellMenuMessstellen, setTrendsCellMenuKenngroessen } from "./trendsCellMenuSlice";
import TrendsCellMenu from "./trendsCellMenu";

export default function TrendsTable(): ReactElement {
  const dispatch = useAppDispatch();
  const classes = {
    ...globalStyles(),
    ...useStyles(),
  };


  const messstelleFilterWert = useAppSelector(selectMessstelleWertTemp);
  const liste_header = useAppSelector(selectKenngroesseListe);
  const liste_horizontal = useAppSelector(selectHorizentalSumListe);
  const liste_vertikal = useAppSelector(selectVertikalSumListe);
  const sum_all = useAppSelector(selectSumAll);
  const trendsListe = useAppSelector(selectTrendsListe);

 
  const selectedCell = useAppSelector(selectSelectedCell);
  const tabList = useAppSelector(selectTrendsGraphTabs);

  const [selectedHeader, setSelectedHeader] = React.useState({
    horizontal: "",
    vertikal: "",
  });


  function getSchaltfeld(name: string) {
    const currentMessstelle = messstelleFilterWert.find(x => x.name == name)
        if (currentMessstelle)
            return `${currentMessstelle.umspannwerk} ${currentMessstelle.schaltfeld} (${currentMessstelle.name})`;
        return "";
  }

  function tooManyTabs() {
    dispatch(openSnackbar({
      message: "Es können maximal 4 Graphs geöffnet werden",
      severity: "info",
      duration: 6000,
    }))
  }

  function createTableCell(elem: string, rows: trendsGeneralObject[]) {
    const rowsMaxIndex = rows.length;
    let rowsIndex = 0;
    while (rowsMaxIndex > rowsIndex) {
      if (elem == rows[rowsIndex].col) {
        return (
          <TableCell
            className={classes.tableCellClickable}
            style={{ cursor: "pointer" }}
            onClick={(e) => {    
              dispatch(setTrendsCellMenuPositionLeft(e.clientX));
              dispatch(setTrendsCellMenuPositionTop(e.clientY));
              dispatch(setSelectedCell(!selectedCell));
              dispatch(setTrendsCellMenuMessstellen(rows[rowsIndex].row));
              dispatch(setTrendsCellMenuKenngroessen(rows[rowsIndex].col));
              if (tabList.length > 4) tooManyTabs();
            }}
            onMouseEnter={() => {
              setSelectedHeader({
                horizontal: rows[rowsIndex].col,
                vertikal: rows[rowsIndex].row,
              });          
            }}
            onMouseLeave={() => {
              setSelectedHeader({
                horizontal: "",
                vertikal: "",
              });
              dispatch(setSelectedCell(false));
            }}
          >
            {rows[rowsIndex].value}
          </TableCell>
        );
      }
      rowsIndex += 1;
    }
    return (
      <Tooltip title="Keine Daten">
        <TableCell className={classes.tableCellKursivStyle}></TableCell>
      </Tooltip>
    );
  }
  return (
    <React.Fragment>
      {selectedCell ? <TrendsCellMenu /> : ""}
      <Grid item md={12} style={{ textAlign: "left", marginRight: "20px" }}>
        <div>
          <TableContainer component={Paper} style={{ height: "80vh" }}>
            <Table aria-label="simple table" className={classes.table}>
              <TableHead>
                <TableCell className={classes.tableHeaderHorizontalLeftmost}>
                  Messstelle / Kenngröße
                </TableCell>
                {liste_header.map((elem, index) => (
                  <TableCell
                    key={index}
                    className={
                      selectedHeader.horizontal == elem
                        ? `${classes.tableHeaderHorizontalFocused}`
                        : `${classes.tableHeaderHorizontal}`
                    }
                  >
                    {elem}
                  </TableCell>
                ))}
                <TableCell
                  className={classes.tableHeaderHorizontalBlank}
                  style={{ width: "20px" }}
                />
                <TableCell className={classes.tableHeaderHorizontal}>
                  Summe der Kenngrößen
                </TableCell>
              </TableHead>
              <TableBody>
                {trendsListe.map((rows, index) => {

                  return (<TableRow key={rows[0].row}>
                    <TableCell
                      className={
                        selectedHeader.vertikal == rows[index]?.row
                          ? `${classes.tableHeaderVerticalFocused}`
                          : `${classes.tableHeaderVertical}`
                      }
                      component="th"
                      scope="rows"
                    >
                    {getSchaltfeld(rows[0].row)}
                    </TableCell>
                    {liste_header.map((elem) => createTableCell(elem, rows))}
                    <TableCell
                      className={classes.tableCellBlank}
                      style={{ width: "20px" }}
                    />
                    {/* eslint-disable-next-line security/detect-object-injection */}
                    <TableCell className={classes.tableCellStyle}>
                      {liste_horizontal[index]}
                    </TableCell>
                  </TableRow>)})}
                <TableRow>
                  <TableCell />
                </TableRow>
                <TableRow>
                  <TableCell
                    className={classes.tableHeaderVertical}
                    style={{ width: "295px" }}
                    component="th"
                    scope="rows"
                  >
                    Summe der Messstellen
                  </TableCell>
                  {liste_vertikal.map((elem, index) => (
                    <TableCell key={index} className={classes.tableCellStyle}>
                      {elem}
                    </TableCell>
                  ))}
                  <TableCell
                    className={classes.tableCellBlank}
                    style={{ width: "20px" }}
                  />
                  <TableCell className={classes.tableCellStyle}>
                    {sum_all}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Grid>
    </React.Fragment>
  );
}
